<template>
    <div :class="['agenda-item', {'agenda-item-bg-reverse': index % 2 == 0}]">
        <h2 class="item-wrap-title-bg" v-if="index == 0">{{ type.split('|')[0].substr(2,10)}}</h2>
        <!-- <h2 class="item-wrap-title" v-if="index == 0">{{ type.split('|')[1] }}</h2> -->
        <h2 class="item-wrap-title" v-if="data.time.split('|')[1]">{{ data.time.split('|')[1] }}</h2>
        <div class="item-wrap"
            :class="{'one-width': data.speaker.length == 1 || data.speaker.length == 0 ,'double-width':data.speaker.length == 2, 'triple-width':data.speaker.length == 3}">
            <div class="agenda-title"> <div class="t-name"> {{ data.time.split('|')[0] }} </div> </div>

            <div class="a-content" v-if="data.subject.split('|')[0] == '圆桌论坛'" >
                <div class="top" v-if="data.speaker[0] && data.speaker[0].photo">
                    <div class="name-title">
                        <div class="photo" v-if="data.speaker[0].photo"><img :src="data.speaker[0].photo" ></div>
                    </div>
                </div>
                <div class="bottom">
                    <p class="bottom-title">{{ data.subject.split('|')[0]}} {{ data.subject.split('|')[1] }}</p>
                </div>
            </div>
             <div class="a-content" v-else>
                <div class="left" v-if="false && data.speaker[0] && data.speaker[0].photo">
                    <div class="name-title">
                        <div class="photo" v-if="data.speaker[0].photo"><img :src="data.speaker[0].photo" ></div>
                    </div>
                </div>
                <div class="right">
                    <p class="subject-type">{{ data.subject.split('|')[0]}}</p> <br>
                    <p class="subject-title" v-html="data.subject.split('|')[1]"></p>
                    <div class="speaker" v-if="data.speaker.length">
                        <div class="speaker-title">主持人：</div>
                        <div class="speaker-content">
                            <p v-for="user in data.speaker"> {{ user.name}}　{{ user.position}}</p>
                        </div>
                    </div>
                    <div class="speaker" v-if="data.guest.length">
                        <div class="speaker-title">嘉　宾：</div>
                        <div class="speaker-content">
                            <p v-for="user in data.guest"> {{ user.name}}　{{ user.position}}</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>


<script>

export default{
    props:['data','type','index']
}

</script>

<style lang="scss" scoped>

.agenda-item{
    vertical-align: top;
    position: relative;
    padding-top: 10px;
    .item-wrap-title-bg {
        font-size: 28px;
        width: 990px;
        text-align: center;
        margin-bottom: 30px;
        padding: 2px;
        background: url('../assets/20-pc/title_bg.png');
        background-size:cover;
    }
    .item-wrap-title {
        font-size: 30px;
        &::before {
            content: '  ';
            width: 30px;
            height: 30px;
            display: inline-block;
            margin-top: 6px;
            vertical-align: top;
            margin-right: 10px;
            background: url('../assets/20-pc/dot.png');
            background-size: cover;
        }
    }
    .item-wrap{
        width: 990px;
        // border: 1px solid red;
        padding-left: 20px;
        .agenda-title{
            border-right: none;
            vertical-align: top;
            width: 100%;
            // border: 1px solid green;
            text-align: left;
            .t-name{
                // border: 1px solid green;
                font-family: 'SourceHanSansCN-Normal';
                margin-left: 20px;
                color: #f2a676;
                display: block;
                line-height: 40px;
                font-size: 24px;
                margin-top: 10px;
                margin-bottom: 10px;
                font-weight: bold;
            }
        }
        .a-content{
            vertical-align: top;
            display: inline-block;
            width: 100%;
            min-height: 50px;
            // border: 1px solid #000;
            .space {
                display: inline-block;
                width: 120px;
                height: 100px;
                // border: 1px solid green;
            }
            .up {
                width: 850px;
            }
            .bottom {
                .bottom-title {
                    margin-left: 20px;
                    margin-top: 10px;
                    margin-bottom: 10px;
                    font-size: 24px;
                    font-weight: bold;
                }
            }
            .left {
                vertical-align: top;
                display: inline-block;
                width: 350px;
                overflow: hidden;
            }
            .left-smail {
                width: 80px;
            }
            .right {
                display: inline-block;
                padding-left: 20px;
                width: 100%;
                min-height: 50px;
            }
            .subject-type{
                // border: 1px solid red;
                font-size: 24px;
                font-weight: bold;
            }
            .subject-title {
                margin-top: 8px;
                font-size: 18px;
                width: 100%;
                letter-spacing: 2px;
                // font-weight: bold;
            }
            .speaker {
                padding-top: 6px;
                font-size: 18px;
                font-weight: bold;
                .speaker-title {
                    // border: 1px solid red;
                    display: inline-block;
                }
                .speaker-content {
                    display: inline-block;
                    vertical-align: top;
                    font-weight: normal;
                    p {
                        padding-bottom: 4px;
                    }
                }
            }

        }
    }
    .one-width{
        // width: 500px;
    }
    .double-width{
        // width: 500px;
    }
    .triple-width{
        // width: 500px;
    }
}
.agenda-item:hover {
    .agenda-title {
        // border: 4px solid #d20000 ;
        // background: #fff;
        .t-name{
            // color: red;
        }
    }
    // margin-left: -20px;
    // margin-top: -20px;
    // height: 170px;
}
</style>



// WEBPACK FOOTER //
// AgendaItem.vue?d361b3e4